import { render, staticRenderFns } from "./privacy-nextagent.vue?vue&type=template&id=16f788f4&scoped=true"
import script from "./privacy-nextagent.vue?vue&type=script&lang=js"
export * from "./privacy-nextagent.vue?vue&type=script&lang=js"
import style0 from "./privacy-nextagent.vue?vue&type=style&index=0&id=16f788f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f788f4",
  null
  
)

export default component.exports